function copy(elemToCopy) {
    elemToCopy.select();
    navigator.clipboard.writeText(elemToCopy.value);
}

export default {
    copy
}
